import { render, staticRenderFns } from "./DIcon.vue?vue&type=template&id=19518006&scoped=true&"
import script from "./DIcon.vue?vue&type=script&lang=js&"
export * from "./DIcon.vue?vue&type=script&lang=js&"
import style0 from "./DIcon.vue?vue&type=style&index=0&id=19518006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19518006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/hwy-client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19518006')) {
      api.createRecord('19518006', component.options)
    } else {
      api.reload('19518006', component.options)
    }
    module.hot.accept("./DIcon.vue?vue&type=template&id=19518006&scoped=true&", function () {
      api.rerender('19518006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/DIcon.vue"
export default component.exports